import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getAllItemViews from '../view/getAllItemViews'
import { checkoutWithMemberPrice, selectShouldUseBookingProtectionMemberPrice, selectShouldUseInsuranceMemberPrice } from '../view/luxPlusSubscription'

function getTotalPrice(
  totals: App.Checkout.ItemViewTotals,
  isMember: boolean,
): number {
  return ((isMember && totals.memberPrice) || totals.price) + totals.extraGuestSurcharge
}

const getCheckoutLuxLoyaltyPointsBurnCalculationRequests = createSelector(
  (state: App.State) => getAllItemViews(state),
  (state: App.State) => checkoutWithMemberPrice(state),
  (state: App.State) => selectShouldUseInsuranceMemberPrice(state),
  (state: App.State) => selectShouldUseBookingProtectionMemberPrice(state),
  (
    allItemViews,
    canCheckoutWithMemberPrice,
    shouldUseInsuranceMemberPrice,
    shouldUseBookingProtectionMemberPrice,
  ): Array<App.Checkout.LuxLoyaltyPointBurnCalculationRequest> => {
    if (!allItemViews.hasRequiredData) return EmptyArray

    const requests: Array<App.Checkout.LuxLoyaltyPointBurnCalculationRequest> = allItemViews.data.values().reduce<Array<App.Checkout.LuxLoyaltyPointBurnCalculationRequest>>((acc, curr) => {
      const view = curr.data
      if (view.luxLoyaltyProductType) {
        switch (view.luxLoyaltyProductType) {
          case 'insurance':
            acc.push({
              item: view.item,
              mx: view.mx,
              price: getTotalPrice(view.totals, shouldUseInsuranceMemberPrice),
              productType: view.luxLoyaltyProductType,
            })
            break
          case 'cfmr':
            acc.push({
              item: view.item,
              mx: view.mx,
              price: getTotalPrice(view.totals, shouldUseBookingProtectionMemberPrice),
              productType: view.luxLoyaltyProductType,
            })
            break
          default:
            acc.push({
              item: view.item,
              mx: view.mx,
              price: getTotalPrice(view.totals, canCheckoutWithMemberPrice),
              productType: view.luxLoyaltyProductType,
            })
        }
      }
      return acc
    }, [])
    return requests
  },
)

export default getCheckoutLuxLoyaltyPointsBurnCalculationRequests
